<div class="usan-form-item sequence-structural-info-oligonucleotides-short-peptides-container">
  <div class="usan-checklist-item">
    <div class="usan-checklist-icon-column">
      <mat-icon>{{ wasFileUploaded ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
    </div>
    <div class="usan-checklist-content-column flex-wrap">
      <span class="required-star" *ngIf="isDocumentRequired">*</span>
      <span class="usan-form-item sequence-item sequence-text" [innerHTML]="title">
      </span>
      <div class="break"></div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormAType">
        <ul>
          <li>
            <a class="link" href="https://www.ama-assn.org/sites/ama-assn.org/files/corp/media-browser/public/usan/sequence-request-format-other-proteins_0.doc" target="_blank">
              Complete mature amino acid sequence AS EDITABLE TEXT in a Microsoft Word document: single letter codes for each amino 
              acid, in groups of 10 characters with 5 groups per line and a number indicating the position of the last amino acid at 
              the end of each line
            </a>
          </li>
          <li>Positions of all disulfide bridges and post-translational modifications should be listed after the sequence</li>
        </ul>
      </div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormBType || isFormFType">
        <ul>
          <li>
            <a class="link" href="https://www.ama-assn.org/sites/ama-assn.org/files/corp/media-browser/public/usan/sequence-request-format-other-proteins_0.doc" target="_blank">
              Complete mature amino acid sequence AS EDITABLE TEXT in a Microsoft Word document: single letter codes for each amino 
              acid, in groups of 10 characters with 5 groups per line and a number indicating the position of the last amino acid at 
              the end of each line
            </a>
          </li>
          <li>Complete precursor nucleotide sequence</li>
          <li>A list of any mutations/amino acid differences with the native sequence (for gene and allele) (e.g. mutations introduced to 
            alter receptor binding or change the isoelectric point, to prevent C1q binding, enhance FcRn binding, etc.)</li>
          <li>Positions of all disulfide bridges and post-translational modifications should be listed after the sequence</li>
          <li>Glycosylation patterns, including site, type of sugar, etc.</li>
          <li>For recombinant proteins: expression system and comparison with native sequence</li>
          <li>If available, the three-dimensional structure in Protein Data Bank format or the Protein Data Bank accession code</li>
          <li>For conjugated proteins: the ratio is the mean numbers of molecules of the conjugated part (indicated by range, thus integer 
            numbers) per molecule of protein</li>
        </ul>
      </div>
      <div class="usan-form-item sequence-item sequence-text" *ngIf="isFormDType">
        <ul>
          <li>
            <a class="link" href="https://www.ama-assn.org/sites/ama-assn.org/files/corp/media-browser/public/usan/sequence-request-format-other-proteins_0.doc" target="_blank">
              Complete mature amino acid sequence in a Microsoft Word document
            </a>
          </li>
          <li>Complete precursor nucleotide sequence</li>
          <li>If applicable, state and explain the purpose of having amino differences with the native sequence (for gene and allele) (e.g. 
            mutations introduced to alter receptor binding or change the isoelectric point, to prevent C1q binding, enhance FcRn binding, 
            etc.)</li>
          <li>Single-letter codes for each amino acid, displayed in groups of 10 characters with 5 groups per line and a number indicating the 
            position of the last amino acid at the end of each line</li>
          <li>Positions of all disulfide bridges and post-translational modifications should be listed after the sequence</li>
          <li>Glycosylation patterns, including site, type of sugar, etc.</li>
          <li>For recombinant proteins: expression system and comparison with native sequence</li>
          <li>If available, the three dimensional structure in Protein Data Bank format or the Protein Data Bank accession code</li>
          <li>For conjugated proteins: the ratio is the mean numbers of molecules of the conjugated part (indicated by range, thus integer 
            numbers) per molecule of protein</li>
        </ul>
      </div>
          
    </div>
  </div>
  <div class="input-error" *ngIf="showRequiredError">
    This is a required document.
  </div>
  <div class="usan-form-item button-layout layout-centered">
    <button type="button" class="upload-sequence-structural-info-oligonucleotides-short-peptides form-btn form-btn-style form-btn-text"
      (click)="openDialog()">
      <mat-icon class="form-btn-icon">upload</mat-icon>
      Upload sequence
    </button>
  </div>
  <ng-container *ngIf="wasFileUploaded">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>